import { ready } from "./custom_utils";

var outerCoatingInput = null;
var innerCoatingInput = null;

var externalCladdingInput = null;
var internalCladdingInput = null;
var controllerData = null;


ready(function () {
    let tempDataEl = document.getElementById("temp_information")
    if (tempDataEl == null)
        return

    controllerData = JSON.parse(tempDataEl.dataset.temp)
    // console.log(controllerData)
    tempDataEl.remove()

    if (controllerData == null) {
        console.log("empty controllerData")
        return;
    }

    outerCoatingInput = document.getElementById(`filter_${controllerData.outerCoatingInputId}_${controllerData.outerCoatingInputType}`)
    innerCoatingInput = document.getElementById(`filter_${controllerData.innerCoatingInputId}_${controllerData.innerCoatingInputType}`)

    internalCladdingInput = document.getElementById(`filter_${controllerData.internalCladdingColourInputId}_Color`)
    externalCladdingInput = document.getElementById(`filter_${controllerData.externalCladdingColourInputId}_Color`)

    externalCladdingInput.addEventListener('change', validateCoating)
    internalCladdingInput.addEventListener('change', validateCoating)
    outerCoatingInput.addEventListener('change', validateCoating)
    innerCoatingInput.addEventListener('change', validateCoating)

    externalCladdingInput.addEventListener('change', (e) => printLayerWarning(e.target))
    outerCoatingInput.addEventListener('change', (e) => printLayerWarning(e.target))
    // This assumes "Food safe" and "Farm" are never the defaults
    // outerCoatingInput.querySelector(`option[value="${controllerData.foodOuterValueId}"]`).setAttribute("disabled", null)
    // innerCoatingInput.querySelector(`option[value="${controllerData.foodInnerValueId}"]`).setAttribute("disabled", null)
}); alert

function printLayerWarning(element) {
    let warningLabel = element.parentElement.querySelector('div.alert.alert-warning')
    if (element.hasAttribute("type") && element.type == "hidden") {
        if (element.value == controllerData.externalColorValueId) {
            warningLabel.removeAttribute("hidden")
        }
        else {
            warningLabel.setAttribute("hidden", null)
        }
    } else if (element.value == controllerData.foodOuterValueId || element.value == controllerData.farmOuterValueId) {
        warningLabel.removeAttribute("hidden")
    } else {
        warningLabel.setAttribute("hidden", null)
    }
}

function validateCoating(event) {
    var targetInput;
    var targetValue;
    var targetOption;

    if (event.target.id == outerCoatingInput.id && event.target.value == controllerData.farmOuterValueId) {
        printLayerWarning(outerCoatingInput)
        return;
    }

    if (event.target.id == outerCoatingInput.id) {
        targetInput = externalCladdingInput
        targetValue = controllerData.foodOuterValueId;
        targetOption = document.querySelector(`a[data-value="${controllerData.externalColorValueId}"]`)
    } else if (event.target.id == innerCoatingInput.id) {
        targetInput = internalCladdingInput
        targetValue = controllerData.foodInnerValueId
        targetOption = document.querySelector(`a[data-value="${controllerData.internalColorValueId}"]`)
    }

    if (event.target.value == targetValue) {
        targetOption.dispatchEvent(new Event('click'))
    }
}

function validateFoodSafety(colorValue, controlIdAttribute) {
    if (controllerData == null)
        return;

    let controlId = Number(controlIdAttribute)
    if (colorValue.includes("foodsafe")) {
        //Check other inputs for valid values
        switch (controlId) {
            case controllerData.internalCladdingColourInputId:
                innerCoatingInput.value = controllerData.foodInnerValueId
                innerCoatingInput.setAttribute("disabled", null)
                break;
            case controllerData.externalCladdingColourInputId:
                outerCoatingInput.value = controllerData.foodOuterValueId
                outerCoatingInput.setAttribute("disabled", null)
                printLayerWarning(outerCoatingInput)
                break;
        }
    } else if (colorValue.toLowerCase().includes("farm") && controlId == controllerData.outerCoatingInputId) {
        printLayerWarning(outerCoatingInput)
    } else {
        if (controlId == controllerData.externalCladdingColourInputId && outerCoatingInput.hasAttribute("disabled")) {
            outerCoatingInput.removeAttribute("disabled")
            outerCoatingInput.selectedIndex = 0
            printLayerWarning(outerCoatingInput)
        }
        if (controlId == controllerData.internalCladdingColourInputId && innerCoatingInput.hasAttribute("disabled")) {
            innerCoatingInput.removeAttribute("disabled")
            innerCoatingInput.selectedIndex = 0
        }
    }
};

window["validateFoodSafety"] = validateFoodSafety
